!function() {
  function e(e, t) {
    let n, i;
    const o = (...o) => {
      i ? (clearTimeout(n), n = setTimeout(() => {
        Date.now() - i >= t && (e(...o), i = Date.now());
      }, t - (Date.now() - i))) : (e(...o), i = Date.now());
    };
    return o.cancel = () => {
      clearTimeout(n), n = null, i = null;
    }, o;
  }
  customElements.get("collection-sticky-bar") || customElements.define("collection-sticky-bar", class extends HTMLElement {
    constructor() {
      super(), this.isVisible = !1, this.collectionSectionEl = this.closest(".collection-product-grid"), 
      this.actionBarEl = this.querySelector(".filter__action-bar"), this.handleScroll = e(this.handleScroll.bind(this), 100), 
      this.handleFilterDrawerChange = this.handleFilterDrawerChange.bind(this), this.handleProductCardViewChange = this.handleProductCardViewChange.bind(this);
    }
    connectedCallback() {
      window.addEventListener("scroll", this.handleScroll), document.addEventListener("change", this.handleProductCardViewChange);
      const e = document.getElementById("filter-level0");
      e && e.addEventListener("change", this.handleFilterDrawerChange), this.handleScroll();
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScroll), document.removeEventListener("change", this.handleProductCardViewChange);
      const e = document.getElementById("filter-level0");
      e && e.removeEventListener("change", this.handleFilterDrawerChange);
    }
    handleScroll() {
      if (!this.collectionSectionEl) return;
      const e = this.collectionSectionEl.getBoundingClientRect().bottom >= window.innerHeight;
      this.style.opacity = e ? null : "0", this.style.pointerEvents = e ? null : "none", 
      this.isVisible !== e && (this.isVisible = e, this._adjustLoadingSpinnerPosition(e));
    }
    handleFilterDrawerChange() {
      this.isVisible && this._adjustLoadingSpinnerPosition(!0);
    }
    handleProductCardViewChange(e) {
      const t = e.target.closest('input[name="product-card-view"]');
      if (!t?.checked) return;
      const n = {
        two: {
          desktop: 2,
          mobile: 1
        },
        four: {
          desktop: 4,
          mobile: 2
        },
        index: {
          desktop: 6,
          mobile: 3
        }
      }[t.value], i = window["depict-grid-rendering-script"];
      n && i && (i.dataset.columnsDesktop = n.desktop, i.dataset.columnsMobile = n.mobile);
    }
    _adjustLoadingSpinnerPosition(e) {
      const t = document.getElementById("filter-level0"), n = t?.checked;
      if (n) {
        const e = this.actionBarEl ? this.actionBarEl.offsetHeight : 0;
        return void document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
          detail: {
            source: "collection-sticky-bar",
            transform: `translateY(-${e}px)`
          }
        }));
      }
      if (e) {
        const e = this.offsetHeight, t = window.getComputedStyle(this), n = e + (parseInt(t.marginTop, 10) || 0) + (parseInt(t.marginBottom, 10) || 0);
        document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
          detail: {
            source: "collection-sticky-bar",
            transform: `translateY(-${n}px)`
          }
        }));
      } else document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
        detail: {
          source: "collection-sticky-bar",
          transform: ""
        }
      }));
    }
  });
  CollectionStickyBar;
}();